// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3WwSX","header":"PatientBlock_header__1b3tc","label":"PatientBlock_label__1ZpRB","option":"PatientBlock_option__23kOr"};